import { useQuery } from "@tanstack/react-query";
import useOwner from "../../users/hooks/useOwner";
import { consultationsApi } from "../consultationsApi";

export function usePatientConsultations(patientId: string, enabled = true) {
  const owner = useOwner();
  return useQuery({
    queryKey: ["patientConsultations", owner, patientId],
    enabled: enabled && !!owner,
    queryFn: () => consultationsApi.list(patientId),
    refetchInterval: (query) =>
      query.state.data?.some((consultation) =>
        ["uploading", "transcribing", "normalizing", "drafting"].includes(
          consultation.status,
        ),
      )
        ? 5_000
        : false,
  });
}
